import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { AlignTarget } from "./";

var Line = function Line(_ref) {
  var strategy = _ref.strategy,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 2000 : _ref$width;
  return /*#__PURE__*/React.createElement(AlignTarget, {
    strategy: strategy,
    lineHeight: 1
  }, function (alignProps) {
    return /*#__PURE__*/React.createElement("div", _extends({}, alignProps, {
      className: "TypeLine"
    }), /*#__PURE__*/React.createElement("div", {
      className: "TypeLine-inner",
      style: {
        left: "".concat(width / -2, "px"),
        right: "".concat(width / -2, "px")
      }
    }));
  });
};

export default Line;